import { renderTemplate } from '../../Utils/templateUtils';

export default class PropertiesApi {

    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(PropertiesApi.SearchPath);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.SearchOpenHousesPath);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.GetAllIds);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.GetById);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.FeaturedByRegion);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.FeaturedByCity);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.FeaturedByNeighborhood);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.FeaturedByOffice);
        this.DashAPI.ApiPathMgr.add(PropertiesApi.FeaturedByAgent);
    }

    searchProperties(params) {
        return this.DashAPI.CORE.get(PropertiesApi.SearchPath, params);
    }

    searchOpenHouseProperties(params) {
        return this.DashAPI.CORE.get(PropertiesApi.SearchOpenHousesPath, params);
    }

    getAllIds() {
        return this.DashAPI.CORE.get(PropertiesApi.GetAllIds);
    }

    getById(propertyId) {
        var urlPath = renderTemplate(PropertiesApi.GetById, { propertyId: propertyId });
        return this.DashAPI.CORE.get(urlPath);
    }

    featuredProperties() {
        return this.DashAPI.CORE.get(PropertiesApi.getFeatured);
    }

    featuredByRegion(regionId) {
        var urlPath = renderTemplate(PropertiesApi.FeaturedByRegion, { regionId: regionId });
        return this.DashAPI.CORE.get(urlPath);
    }

    featuredByCity(cityId) {
        var urlPath = renderTemplate(PropertiesApi.FeaturedByCity, { cityId: cityId });
        return this.DashAPI.CORE.get(urlPath);
    }

    featuredByNeighborhood(neighborhoodId) {
        var urlPath = renderTemplate(PropertiesApi.FeaturedByNeighborhood, { neighborhoodId: neighborhoodId });
        return this.DashAPI.CORE.get(urlPath);
    }

    featuredByOffice(officeId) {
        var urlPath = renderTemplate(PropertiesApi.FeaturedByOffice, { officeId: officeId });
        return this.DashAPI.CORE.get(urlPath);
    }

    featuredByAgent(agentId) {
        var urlPath = renderTemplate(PropertiesApi.FeaturedByAgent, { agentId: agentId });
        return this.DashAPI.CORE.get(urlPath);
    }

    randomProperties() {
        return this.DashAPI.CORE.get(PropertiesApi.getRandom);
    }

    recentlySoldByAgent(agentId) {
        var urlPath = renderTemplate(PropertiesApi.recentlySoldByAgent, { agentId: agentId });
        return this.DashAPI.CORE.get(urlPath);
    }

    searchFeaturedOpenHouses(searchParams) {
        return this.DashAPI.CORE.get(PropertiesApi.FeaturedOpenHousesPath, searchParams);
    }

    getSitemap() {
        return this.DashAPI.CORE.getXML(PropertiesApi.SitemapPath);
    }

    getPropertiesSearchSitemap() {
        return this.DashAPI.CORE.getXML(PropertiesApi.SiteMapSearchPath);
    }
}

PropertiesApi.SitemapPath = '/api/properties/sitemap';
PropertiesApi.SearchPath = '/api/properties/search';
PropertiesApi.SiteMapSearchPath = '/api/properties/search/sitemap';
PropertiesApi.SearchOpenHousesPath = '/api/properties/search/open-houses';
PropertiesApi.GetAllIds = '/api/properties/ids';
PropertiesApi.GetById = '/api/properties/detail/{propertyId}';
PropertiesApi.getFeatured = 'api/properties/featured';
PropertiesApi.FeaturedByRegion = 'api/properties/featured/region/{regionId}';
PropertiesApi.FeaturedByCity = 'api/properties/featured/cities/{cityId}';
PropertiesApi.FeaturedByNeighborhood = 'api/properties/featured/neighborhoods/{neighborhoodId}';
PropertiesApi.FeaturedByOffice = 'api/properties/featured/office/{officeId}';
PropertiesApi.FeaturedByAgent = 'api/properties/featured/agent/{agentId}';
PropertiesApi.recentlySoldByAgent = 'api/properties/sold/agent/{agentId}';
PropertiesApi.getRandom = 'api/properties/random';
PropertiesApi.FeaturedOpenHousesPath = 'api/properties/open-houses/featured';



// WEBPACK FOOTER //
// ./src/PublicApi/properties/PropertiesApi.js


// WEBPACK FOOTER //
// webpack:///src/PublicApi/properties/PropertiesApi.js